import {useNavigation} from '@react-navigation/core';
import React, {memo, useState} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';
import {AccountDeletionConfirmation} from '..';

import {RNEButton, RNEInput, RNEText} from '../../components';
import {NavigationKey} from '../../navigations/config';
import DownloadMedicalRecords from './DownloadMedicalRecords';
import { width, height, totalSize } from 'react-native-dimension';
import { Text } from 'react-native';
import { colorPalette } from '../../../core/config/color.config';
import { Alert } from 'react-native';

interface AccountPermanentDeleteProps {
  onCancel: () => void;
  onDoctorDelete?: () => void;
  patientId?: string;
  forDoctor?: boolean;
  accountOwner?: boolean;
}

function AccountPermanentDelete(props: AccountPermanentDeleteProps) {
  const navigation = useNavigation();

  const [confirmText, setConfirmText] = useState('');

  


  const handleDeleteAccount = () => {
    console.log(confirmText)

    if (confirmText.toLowerCase() === 'delete') {
      
    }else{
      Alert.alert('Error', 'Please type DELETE to confirm.');
    }
  };

  return (
    <View style={rneStyles.root}>
        <>
          <RNEText
            label={
             'Are you sure you want to Delete your Accoun1t?'
            }
            variant="header"
            align="center"
            color="accent"
            style={{fontSize: totalSize(2.5), fontFamily:'Quicksand-Bold'}}
            
          />

          <View style={rneStyles.subtitleContainer}>
              <RNEText
                label={
                  'Deleting your account will permanently erase all your data. You will no longer be able to access your account or log in again. This action is irreversible. Do you want to continue?'
                }
                variant="body"
                align="center"
                style={{fontSize: totalSize(1.5), fontFamily:'Quicksand-SemiBold'}}
              />
            
          </View>

          <View style={{marginTop: totalSize(2), marginBottom: totalSize(2)}}>
            <Text style={{fontFamily:'Quicksand-SemiBold',fontSize: totalSize(1.5), textAlign:'center'}}>To confirm, please type <Text style={{color: colorPalette.error, fontFamily:'Quicksand-Bold'}}>DELETE</Text> in the box below.</Text>
          </View>

          <View>
              <RNEInput
                placeholder="Type DELETE to confirm"
                value={confirmText}
                onChangeText={text => setConfirmText(text)}
              />
          </View>

          <View style={rneStyles.actionContainer}>
            <View style={rneStyles.buttonContainer}>
              <RNEButton
                title="Cancel"
                color="secondary"
                onPress={props.onCancel}
                style={rneStyles.buttonStyle}
                variant="outlined"
              />
            </View>
            <RNEButton
              title="Delete Anyway"
              color="secondary"
              onPress={handleDeleteAccount}
              style={rneStyles.buttonStyle}
              
            />
          </View>
        </>
    </View>
  );
}

const rneStyles = StyleSheet.create( ({
  root: {
    justifyContent: 'center',
    width: width(75),
  },
  subtitleContainer: {
    marginTop: 40,
  },
  actionContainer: {
    marginTop: totalSize(4.5),
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginRight: 16,
  },
  buttonStyle: {
    width: width(40),
    borderWidth: totalSize(0.1)
  },
}));

export default memo(AccountPermanentDelete);
